import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IAffiliateProgramCreativesListItem } from '@modules/affiliate-program-creatives/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import type {
  ITableDataResponse,
  ITableState,
} from '@modules/tables/types';
import { AFFILIATE_TRACKERS_PERMISSIONS } from '@modules/affiliate-trackers/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import {
  AFFILIATE_TRACKERS_CREATIVES_LIST_QUERY_KEY,
  AFFILIATE_TRACKERS_CREATIVES_LIST_URL,
} from '../constants';

export default function useAffiliateTrackerCreativesListQuery(
  tableState: Ref<ITableState>,
  type: Ref<string | undefined>,
  isDisabled: Ref<boolean>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramCreativesListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramCreativesListItem>>({
    queryKey: [AFFILIATE_TRACKERS_CREATIVES_LIST_QUERY_KEY, tableState, type],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramCreativesListItem>>(
      AFFILIATE_TRACKERS_CREATIVES_LIST_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW_CREATIVE,
        urlParams: {
          type: type.value,
        },
      },
    ),
    placeholderData: keepPreviousData,
    enabled: computed(() => !isDisabled.value && !!type.value),
  });
}
